import { CertificateDocumentsVendorInfo } from "@/mocks/data/vendorService/certificatesDocuments";
const vendorInformation = {
    getVendorInfoDropdownData: async (): Promise<any> =>{
        try {
        // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
        const resp = CertificateDocumentsVendorInfo;
        return resp ? resp : null;
        } catch (error) {
            console.error("Error fetching vendor data:", error);
            throw error;
        }
    }
};
 
export default vendorInformation;